/* Factories */
import CoherentBookingFactory from "./factory";

/* Facades */
import CoherentBookings from "./facade";

const modul = angular

    .module("CoherentBookingsModule", [])

    /**
     * Services
     * * can only have utility dependencies
     */

    /**
     * Storage
     * can only have utility and services as dependencies
     */

    /**
     * Factories
     */
    .factory("CoherentBookingFactory", CoherentBookingFactory)

    /**
     * Facades
     */
    .factory("CoherentBookings", CoherentBookings);

export default modul.name;
